import {AbSelectOption} from "@/scripts/components/ab-select/ab-select.types";

export const buildDom = () => {
  return `
    <div class="ab-select__search">
      <input
        placeholder="Cerca un modello..."
        class="ab-select__input"
        type="text"
        autocomplete="off"
      />
    </div>
    <div class="ab-select__panel">
      <div class="ab-select__list" role="listbox"></div>
    </div>
  `;
}

export const buildListItems = (
  options: AbSelectOption[]
) => {

  if (!options?.length) {
    return `
          <div class="ab-select__no-results">
            Nessun risultato
          </div>
        `;
  }

  type OptionWithIndex = { option: AbSelectOption; index: number };

  const grouped: { name: string; items: OptionWithIndex[] }[] = [];
  const groupedLookup = new Map<string, OptionWithIndex[]>();
  const ungrouped: OptionWithIndex[] = [];

  options.forEach((option, index) => {
    const groupName = option.group?.trim();

    if (groupName) {
      if (!groupedLookup.has(groupName)) {
        const items: OptionWithIndex[] = [];
        groupedLookup.set(groupName, items);
        grouped.push({ name: groupName, items });
      }
      groupedLookup.get(groupName)!.push({ option, index });
      return;
    }

    ungrouped.push({ option, index });
  });

  const buildItems = (items: OptionWithIndex[]) =>
    items
      .map(({ option, index }) => {
        const descriptionHtml = option.description
          ? `<div class="ab-select__item-description">${option.description}</div>`
          : "";
        return `
            <div
              class="ab-select__item"
              data-index="${index}"
              role="option"
            >
              <div class="ab-select__item-label">${option.label}</div>
              ${descriptionHtml}
            </div>
          `;
      })
      .join("");

  const groupedHtml = grouped
    .map(({ name, items }, idx) => `
          <div
            class="ab-select__group"
            role="group"
            aria-labelledby="ab-select-group-title-${idx}"
          >
            <h4
              id="ab-select-group-title-${idx}"
              class="ab-select__group-title"
            >${name}</h4>           
            <div class="ab-select__group-items"> 
              ${buildItems(items)}
            </div>           
          </div>
        `)
    .join("");

  const ungroupedHtml = ungrouped.length
    ? `
          <div class="ab-select__group ab-select__group--ungrouped" role="none">
            <div class="ab-select__group-items">
              ${buildItems(ungrouped)}
            </div>
          </div>
        `
    : "";

  return `${groupedHtml}${ungroupedHtml}`;
}
